import { Branch } from "@/model/data/Branch";
import { API_PREFIX, API_VERSION, Command, HttpVerbType } from "../Command";
import { GetBranchesResData } from "./GetBranchesResData";

const ENDPOINT = "/branch";

export class CreateBranchCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "post";

    params: CreateBranchReqData = null;

    constructor(branch: Branch, createFolder: boolean) {
        super();
        this.params = new CreateBranchReqData(branch, createFolder);
    }

    public async execute(): Promise<GetBranchesResData> {
        var res = await this.executeCommand(this.params);
        return new GetBranchesResData(res);
    }
}

export class CreateBranchReqData {
    branch: Branch;
    createFolder: boolean;

    constructor(branch: Branch, createFolder: boolean) {
        this.branch = branch;
        this.createFolder = createFolder;
    }
}
